import { Loader2Icon } from 'lucide-react';
import type { FC } from 'react';
import { cn } from '@/lib/utils';

type LoadingSpinnerProps = {
  className?: string;
};

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ className }) => {
  return (
    <div className={cn('flex items-center justify-center p-12', className)}>
      <Loader2Icon className="size-26 animate-spin text-primary" />
    </div>
  );
};
